import axiosInstance from '../../../store/api';
import { create } from 'zustand';

export const useInventarioSaving = create(() => ({ pending: 0 }));

const save = async (request) => {
  useInventarioSaving.setState(({ pending }) => ({ pending: pending + 1 }));
  try {
    return await request();
  } finally {
    useInventarioSaving.setState(({ pending }) => ({ pending: pending - 1 }));
  }
};

const BASE = '/config/inventario';

const unwrapPayload = (payload) => {
  if (!payload || typeof payload !== 'object') return payload;
  if (payload.result !== undefined) return payload.result;
  if (payload.data !== undefined) return payload.data;
  if (payload.item !== undefined) return payload.item;
  return payload;
};

const normalize = (doc) => {
  if (!doc) return doc;
  const unwrapped = unwrapPayload(doc);
  if (unwrapped !== doc) return normalize(unwrapped);
  if (Array.isArray(doc)) return doc.map(normalize);
  const { _id, __v, user, ...rest } = doc;
  return { id: _id || rest.id, ...rest };
};

const h = (entidad) => ({ 'X-Entidad': entidad });

const requireAuth = () => {
  if (!localStorage.getItem('token')) {
    return Promise.reject(new Error('No autenticado'));
  }
};

export const inventarioApi = {
  getAll: (entidad) =>
    requireAuth() || axiosInstance.get(BASE, { headers: h(entidad) }).then(r => normalize(r.data)),

  getById: (entidad, id) =>
    requireAuth() || axiosInstance.get(BASE, { params: { id }, headers: h(entidad) }).then(r => normalize(r.data)),

  create: (entidad, body) =>
    save(() => requireAuth() || axiosInstance.post(BASE, body, { headers: h(entidad) }).then(r => normalize(r.data))),

  replace: (entidad, body) =>
    save(() => requireAuth() || axiosInstance.put(BASE, body, { headers: h(entidad) }).then(r => normalize(r.data))),

  patch: (entidad, body) =>
    save(() => requireAuth() || axiosInstance.patch(BASE, body, { headers: h(entidad) }).then(r => normalize(r.data))),

  remove: (entidad, id) =>
    save(() => requireAuth() || axiosInstance.delete(BASE, { params: { id }, headers: h(entidad) }).then(r => normalize(r.data))),

  previewCorreccion: body => save(() => requireAuth() || axiosInstance.post(BASE + '/correcciones/preview', body).then(r => r.data)),
  aplicarCorreccion: body => save(() => requireAuth() || axiosInstance.post(BASE + '/correcciones', body).then(r => r.data)),
  listarCorrecciones: params => requireAuth() || axiosInstance.get(BASE + '/correcciones', { params }).then(r => r.data),
  getHistorial: (params = {}) =>
    requireAuth() || axiosInstance.get(`${BASE}/historial`, { params }).then(r => normalize(r.data)),

  bulkMigrate: (payload) =>
    save(() => requireAuth() || axiosInstance.post(`${BASE}/migrate`, payload).then(r => r.data)),

  crearLimpieza: (body) =>
    save(() => requireAuth() || axiosInstance.post(`${BASE}/limpiezas`, body).then(r => normalize(r.data))),

  listarLimpiezas: (params = {}) =>
    requireAuth() || axiosInstance.get(`${BASE}/limpiezas`, { params }).then(r => normalize(r.data)),

  anularLimpieza: (id) =>
    save(() => requireAuth() || axiosInstance.post(`${BASE}/limpiezas/${id}/anular`).then(r => normalize(r.data))),

  convertirGastoALimpieza: (gastoId, body) =>
    save(() => requireAuth() || axiosInstance.post(`${BASE}/gastos/${gastoId}/convertir-a-limpieza`, body).then(r => r.data)),
};

export const isOfflineError = (error) =>
  !error.response && (error.message === 'Network Error' || !navigator.onLine);

const CACHE_PREFIX = 'inv_cache_';

export const cache = {
  get: (entidad) => {
    try { return JSON.parse(localStorage.getItem(CACHE_PREFIX + entidad)); }
    catch { return null; }
  },
  set: (entidad, data) => {
    localStorage.setItem(CACHE_PREFIX + entidad, JSON.stringify(data));
  },
};
